import { Moment } from "moment";
import "./subfolders.scss";
import { useCallback, useState, useEffect } from "react";
import api from "api";
import { ClipType } from "types";
import { useDispatch } from "react-redux";
import { actions } from "redux/reducers";

interface Subfolder {
    Id: number;
    Children: Subfolder[];
    Name: string;
    ClipCount: number;
    BinTypeId: number;
}

interface prop {
    projectId: number;
    dateFrom: Moment;
    dateTo: Moment;
    streamIds: number[];
    setSubfolder: (id: number) => void;
}

function Subfolders({ projectId, dateFrom, dateTo, streamIds, setSubfolder }: prop) {
    const [subfolders, setSubfolders] = useState<Subfolder[]>([]);
    const [subfolderOptionView, setSubfolderOptionView] = useState<number>();
    const [openSubfolders, setOpenSubfolders] = useState<number[]>([]);
    const [openSubfolder, setOpenSubfolder] = useState<string>("");
    const [showAll, setShowAll] = useState<boolean>(false);
    const [event, setEvent] = useState<any>();
    const [overlay, setOverlay] = useState<boolean>(false);
    const [subfolderId, setSubfolderId] = useState<number | null>(null);
    var subfolderLevel = 0;
    const dispatch = useDispatch();

    const getSubfoldersAsTreeview = useCallback(async () => {
        const data = await api.subfolders.getAllAsTreeviewBinType(subfolderId ? subfolderId : projectId, dateFrom, dateTo, streamIds);
        console.log(
            "DATA",
            data.filter((x: Subfolder) => x.BinTypeId === 6)
        );

        setSubfolders(data);
    }, [projectId, dateFrom, dateTo, streamIds, subfolderId]);

    const renderSubfolder = (x: Subfolder, i: number, subfolderLevel: number) => {
        subfolderLevel += 1;
        console.log("Item", x, subfolderLevel);

        return (
            <div
                className="subfolder"
                key={i}
                onClick={(e) => {
                    e.stopPropagation();
                    setSubfolderOptionView(x.Id);
                    setEvent(e);
                    setOverlay(true);
                }}
            >
                <i
                    className={`fal fa-angle-${openSubfolders.includes(x.Id) ? "down" : "right"} ${!x.Children.length ? "blank" : ""}`}
                    onClick={(e) => {
                        openChildren(x.Id);
                        e.stopPropagation();
                    }}
                ></i>
                <span>{x.ClipCount}</span>
                <p className={"level-" + subfolderLevel}>{x.Name}</p>
                <div className={`children ${openSubfolders.includes(x.Id) ? "open" : ""}`}>
                    {
                        !showAll
                            ? x.Children.filter((x) => x.ClipCount > 0).map((c: any, index: number) => {
                                  return renderSubfolder(c, index, subfolderLevel);
                              })
                            : x.Children.map((cc: any, ii: number) => {
                                  return renderSubfolder(cc, ii, subfolderLevel);
                              })

                        // x.Children.map((c: Subfolder, index: number) => {
                        //     return renderSubfolder(c, index);
                        // })
                    }
                </div>
                {subfolderOptionView === x.Id && (
                    <div className="subfolder-actions" style={{ top: event.pageY, left: event.pageX + 5 }}>
                        <span
                            onClick={(ev) => {
                                viewSubfolderPosts(x.Id);
                                ev.stopPropagation();
                            }}
                        >
                            View Posts
                        </span>
                        <span
                            onClick={(ev) => {
                                setSubfolderAsDashboard(x.Id, x.Name);
                                ev.stopPropagation();
                            }}
                        >
                            Set As Dashboard
                        </span>
                    </div>
                )}
            </div>
        );
    };

    const openChildren = (id: number) => {
        let array = [...openSubfolders];
        if (array.includes(id)) {
            array.splice(array.indexOf(id), 1);
        } else {
            array.splice(0, 0, id);
        }
        setOpenSubfolders(array);
    };

    async function viewSubfolderPosts(subfolderProjectId: number) {
        setSubfolderOptionView(0);
        setOverlay(false);
        const clips: ClipType[] = await api.clip.getAll(subfolderProjectId, dateFrom, dateTo, streamIds.join(","));
        dispatch(
            actions.clipTray.set({
                open: true,
                clips: clips,
            })
        );
    }

    function setSubfolderAsDashboard(id: number, name: string) {
        console.log(id);
        setSubfolderId(id);
        setSubfolder(id);
        setOverlay(false);
        setSubfolderOptionView(0);
        setOpenSubfolder(name);
    }

    useEffect(() => {
        getSubfoldersAsTreeview();
    }, [getSubfoldersAsTreeview]);

    return (
        <div className="subfolders">
            <div className="top">
                <p>Sortbins</p>
                <div className="input-group">
                    <label htmlFor="checkbox-subfolders-show-all">Show All</label>
                    <input type="checkbox" id="checkbox-subfolders-show-all" checked={showAll} onChange={() => setShowAll(!showAll)} />
                </div>
            </div>
            <div className="body">
                <div className="my-gid">
                    <div className="inputBinContainer">
                        <div className="section-header">Input bins</div>
                        {subfolders
                            .filter((x: Subfolder) => x.BinTypeId === 6)
                            .map((x) => (
                                <div className="subfolder">
                                    <i className="fal fa-angle-right blank"></i>
                                    <p className="primary">{x.Name}</p>
                                    <div className="children "></div>
                                </div>
                            ))}
                    </div>
                    <div>
                        <div className="section-header"> Subfolders</div>
                        {!subfolders.some((x) => x.ClipCount > 0) && !showAll ? (
                            <i>No clips found for subfolders</i>
                        ) : !showAll ? (
                            subfolders
                                .filter((x) => x.ClipCount > 0)
                                .map((x: any, i: number) => {
                                    return renderSubfolder(x, i, 0);
                                })
                        ) : (
                            subfolders.map((x: any, i: number) => {
                                return renderSubfolder(x, i, 0);
                            })
                        )}
                    </div>
                </div>
            </div>
            {overlay && (
                <div
                    className="overlay"
                    onClick={() => {
                        setSubfolderOptionView(0);
                        setOverlay(false);
                    }}
                ></div>
            )}
            {subfolderId && (
                <div
                    className="subfolder-label"
                    onClick={() => {
                        setSubfolder(projectId);
                        setSubfolderId(null);
                    }}
                >
                    <span>
                        {openSubfolder}
                        <i className="fal fa-times close-button"></i>
                    </span>
                </div>
            )}
        </div>
    );
}

export default Subfolders;
